function adjacentVertexConstrained(
  fabs,
  loop,
  loopIndex,
  prevIndex,
  nextIndex,
) {
  if (fabs[loopIndex]) return true;

  if (fabs[prevIndex]) {
    const corner = loop[prevIndex];
    const toDelete = loop[loopIndex];
    const opposite = loop[nextIndex];
    if (corner.y === toDelete.y && corner.y !== opposite.y) return true;
    if (corner.x === toDelete.x && corner.x !== opposite.x) return true;
  }

  if (fabs[nextIndex]) {
    const corner = loop[nextIndex];
    const toDelete = loop[loopIndex];
    const opposite = loop[prevIndex];
    if (corner.y === toDelete.y && corner.y !== opposite.y) return true;
    if (corner.x === toDelete.x && corner.x !== opposite.x) return true;
  }

  return false;
}

export { adjacentVertexConstrained };
